import * as React from 'react';
import axios from 'axios';
import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Select, MenuItem, Button, DialogActions, Typography, Box, IconButton, InputAdornment, InputLabel } from '@mui/material';
import { Backdrop, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { parseColombianMoneyInput } from '../../../utils/money';

const API_URL = process.env.REACT_APP_API_URL;

export default function DialogCreateTarifa({ openDialog, handleCloseDialog, setOpenDialog, handleRefreshData }) {
  const [nombre, setNombre] = useState("");
  const [valor, setValor] = useState("");
  const [tarifaInicial, setTarifaInicial] = useState("");
  const [horasIniciales, setHorasIniciales] = useState("");
  const [tarifaAdicional, setTarifaAdicional] = useState("");
  const [descuento, setDescuento] = useState("");
  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);
  const submitRef = React.useRef(false);

  const [fieldErrors, setFieldErrors] = useState({
    nombre: false,
    valor: false,
    tarifaInicial: false,
    horasIniciales: false,
    tarifaAdicional: false,
    descuento: false,
  });

  const validateFields = () => {
    const errors = {
          nombre: nombre.trim() === "",
          tarifaInicial: tarifaInicial === "",
          horasIniciales: horasIniciales === "",
          tarifaAdicional: tarifaAdicional === "",
          descuento: descuento === "",
        };
    setFieldErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

const handleCreateTarifa = async () => {
  if (submitRef.current || loading) return;
  if (!validateFields()) {
    setError("Por favor, complete todos los campos.");
    return;
  }
  submitRef.current = true;
  setLoading(true);

  try {
    const data = {
      nombre,
      tarifa_inicial: parseColombianMoneyInput(tarifaInicial),
      horas_iniciales: horasIniciales,
      tarifa_adicional: parseColombianMoneyInput(tarifaAdicional),
      descuento,
    };
    await axios.post(`${API_URL}/tarifas/`, data, { headers: { "Content-Type": "application/json" } });
    setNombre("");
    setValor("");
    setTarifaInicial("");
    setHorasIniciales("");
    setTarifaAdicional("");
    setDescuento("");

    handleRefreshData();
    setOpenDialog(false);
    setLoading(false);

  } catch (error) {
    setLoading(false);
    if (error.response) {
      console.error("Error en la respuesta del servidor:", error.response.data);
      setError("Error: Falta o hay mala información en este auto (Verifique si ya ha sido creado)");
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor:", error.request);
      setError("Error: El servidor no ha dado una respuesta");
    } else {
      console.error("Error al configurar la solicitud:", error.message);
      setError("Error: Falta o hay mala información en este auto (Verifique si ya ha sido creado)");
    }
  } finally {
    submitRef.current = false;
    setLoading(false);
  }
};


  return (
    <Dialog open={openDialog} onClose={handleCloseDialog} sx={{ '& .MuiPaper-root': { width: '60%', maxWidth: 'none' } }}>
        <Backdrop
          open={loading}
          style={{ zIndex: 9999, color: '#fff' }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

      <DialogTitle>Ponga la Información de la nueva Tarifa</DialogTitle>
      <DialogContent>
        <>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre"
            fullWidth
            value={nombre}
            error={fieldErrors.nombre}
            helperText={fieldErrors.nombre ? "Este campo es obligatorio" : ""}
            onChange={(e) => setNombre(e.target.value.toUpperCase())}
          />

          <TextField
            autoFocus
            margin="dense"
            label="Tarifa Inicial"
            fullWidth
            type="text"
            inputMode="decimal"
            value={tarifaInicial}
            onChange={(e) => setTarifaInicial(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            error={fieldErrors.tarifaInicial}
            helperText={fieldErrors.tarifaInicial ? "Este campo es obligatorio" : ""}
          />

          <TextField
            margin="dense"
            label="Horas Iniciales"
            fullWidth
            type="number"
            value={horasIniciales}
            onChange={(e) => setHorasIniciales(e.target.value)}
            error={fieldErrors.horasIniciales}
            helperText={fieldErrors.horasIniciales ? "Este campo es obligatorio" : ""}
          />

          <TextField
            margin="dense"
            label="Tarifa Adicional"
            fullWidth
            type="text"
            inputMode="decimal"
            value={tarifaAdicional}
            onChange={(e) => setTarifaAdicional(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            error={fieldErrors.tarifaAdicional}
            helperText={fieldErrors.tarifaAdicional ? "Este campo es obligatorio" : ""}
          />

          <TextField
            margin="dense"
            label="Descuento"
            type="number"
            fullWidth
            value={descuento}
            onChange={(e) => setDescuento(e.target.value)}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            error={fieldErrors.descuento}
            helperText={fieldErrors.descuento ? "Este campo es obligatorio" : ""}
          />
        </>

      </DialogContent>

      {error && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: "#d32f2f", padding: 1, borderRadius: 1, width: '95%' }}>
            <Typography sx={{ color: "white", fontWeight: 'bold', marginRight: 1 }}>{error}</Typography>
            <IconButton color="inherit" onClick={() => setError("")}><CloseIcon /></IconButton>
          </Box>
        </Box>
      )}

      <DialogActions>
        <Button onClick={handleCloseDialog} variant="outlined" color="error">Cancelar</Button>
        <Button onClick={handleCreateTarifa} color="primary" variant="contained" disabled={loading}>Crear</Button>
      </DialogActions>
    </Dialog>
  );
}
